import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RateQuote } from '../../modules/rate-quote/types';
import { defaultLinkModalState } from './state';

export const formatRatesLink = (link: string) => {
  return `${process.env.MY_OWNUP_BASE_URL}rates/${link}`;
};

export const linkModalSlice = createSlice({
  name: 'linkModal',
  initialState: defaultLinkModalState,
  reducers: {
    closeLinkModal: (state) => ({
      ...state,
      title: null,
      isOpen: false
    }),
    publishRateQuoteRequest: (state, _: PayloadAction<string>) => ({
      ...state,
      isOpen: true,
      loading: true,
      title: 'Publishing...',
      networkError: null
    }),
    publishRateQuoteSuccess: (state, _: PayloadAction<{ rateQuote: RateQuote; link: string }>) => ({
      ...state,
      link: null,
      loading: false,
      title: 'Successfully published.',
      message: "Updated offers have been published to the customer's account.",
      networkError: null
    }),
    publishRateQuoteFailure: (state, { payload }: PayloadAction<string>) => ({
      ...state,
      loading: false,
      title: 'Error',
      message: null,
      networkError: payload
    }),
    previewRateQuoteRequest: (state, _: PayloadAction<string>) => ({
      ...state,
      isOpen: true,
      loading: true,
      title: 'Preparing Preview...',
      networkError: null
    }),
    previewRateQuoteSuccess: (state, { payload }: PayloadAction<string>) => ({
      ...state,
      link: formatRatesLink(payload),
      loading: false,
      title: 'Preview rates.',
      message: 'Rates are ready for preview.',
      networkError: null
    }),
    previewRateQuoteFailure: (state, { payload }: PayloadAction<string>) => ({
      ...state,
      loading: false,
      title: 'Error',
      message: null,
      networkError: payload
    }),
    submitRateQuoteRequest: (
      state,
      _: PayloadAction<{ rateQuoteId: string; rateQuoteRequestId: string }>
    ) => ({
      ...state,
      isOpen: true,
      loading: true,
      title: 'Submitting...',
      networkError: null
    }),
    submitRateQuoteSuccess: (state) => ({
      ...state,
      link: `${window.location.href}`,
      loading: false,
      title: 'Successfully submitted.',
      message: 'Rates are ready for advisor review.',
      networkError: null
    }),
    submitRateQuoteFailure: (state, { payload }: PayloadAction<string>) => ({
      ...state,
      loading: false,
      title: 'Error',
      message: null,
      networkError: payload
    })
  }
});

export const {
  closeLinkModal,
  publishRateQuoteRequest,
  publishRateQuoteSuccess,
  publishRateQuoteFailure,
  previewRateQuoteRequest,
  previewRateQuoteSuccess,
  previewRateQuoteFailure,
  submitRateQuoteRequest,
  submitRateQuoteSuccess,
  submitRateQuoteFailure
} = linkModalSlice.actions;

export const reducer = linkModalSlice.reducer;
